export const baseUrl =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://gateway.hapi.hmgroup.com/boxers-gateway/v1'
    : process.env.REACT_APP_ENV === 'test'
    ? 'https://gateway-test.hapi.hmgroup.com/boxers-gateway/v1'
    : 'https://gateway-test.hapi.hmgroup.com/dev/boxers-gateway/v1';

export const baseUrlCDN = 'https://boxers.azureedge.net';
export const localhost = 'http://0.0.0.0:8000';

export const dreamCatcherUrl = 'https://assets.hm.com/v2';
export const dreamCatcherSecret = 'dreamcatcher';

// Transaction Search
export const transactionEndpoint = '/transactions';
export const transactionSearchEndpoint = '/transaction-search';
export const countEndpoint = '/count';
export const receiptEndpoint = '/receipt';
export const salesNetWidgetEndpoint = '/netSales';
export const conversionRateWidgetEndpoint = '/conversionRate';
export const topSellingGarmentEndpoint = '/topSellingGarments';
export const shareOfReceiptsEndpoint = '/shareOfReceipts';
export const newMembersEndpoint = '/newMembers';
export const appCustomersEndpoint = '/newAppCustomers';
export const averageNetSalePerReceiptEndpoint = '/averageNetSalePerReceipt';
export const budgetPlannedEndpoint = '/budgetAndPlanned';
export const effectiveHoursEndpoint = '/effectiveHours';
export const receiptSalesAnalysisEndpoint = '/receiptSalesAnalysis';
export const averagePiecesPerReceipt = '/averagePiecesPerReceipt';
export const queueLengthEndpoint = '/queueLength';
export const takt1Endpoint = '/takt1';
export const sptEndpoint = '/spt';
export const customerFeedbackEndpoint = '/customerFeedback';
export const scoEndpoint = '/sco';
export const orisCustomersEndpoint = '/orisCustomers';
export const customerEngagementEndpoint = '/customerEngagement';
export const salesInsightsEndpoint = '/sales-insight';
export const helpASaleEndpoint = '/helpASale';
export const bopisEndpoint = '/bopis';
export const bopisLeadTimeEndpoint = '/bopisleadtime';

// RFID
export const rfidEndpoint = '/rfid';
export const rfidSalesRetaggingEndpoint = '/salesAndRetagging';
export const rfidApprovalsEndpoint = '/approvals';
export const rfidCountEndpoint = '/stockCount';
export const stockInventoryCountEndpoint = '/storeInventoryCount';
export const stockAccuracyEndpoint = '/stockAccuracy';

// Sold Products
export const soldProductsEndpoint = '/sold-products';
export const productsEndpoint = '/products/';
export const detailsEndpoint = '/details';
export const topSellingGarmentPageEndpoint = '/soldProducts';
export const productCategoryEndpoint = '/productIndex';

// Sales Analysis
export const salesAnalysisEndpoint = '/sales-analysis';

// Translations
export const translationEndpoint = '/translations/';
export const translationMappingEndpoint = '/translation-mapping'; // TODO: update this with the correct endpoint

// Profiles
export const profilesEndpoint = '/profiles';
export const updateProfileEndpoint = '/profiles/update';
export const avatarIsUniqueEndpoint = '/profiles/avatars/isUnique';
export const messagesEndpoint = '/profiles/:upn/messages';

// CDN
export const avatarsEndpoint = '/avatars';

// Stores
export const storeEndpoint = '/stores';
export const highlightedWidgetsEndpoint = '/highlightedWidgets';
export const updateHighlightedWidgetsEndpoint = '/highlightWidgets';
export const profitAndLossEndpoint = '/profitAndLoss';
export const nearbyStoresEndpoint = '/nearbyStores';
export const allStoreDetailsEndpoint = '/allStoreDetails';

// Weather Widget
export const weatherWidgetEndpoint = '/weatherWidget';

// Authorization model
export const authorizationEndpoint = '/authorization-model';
export const permissionsEndpoint = '/permissions';
export const blacklistPermissions = '/blacklist-permissions';
export const userAccessRequestEndpoint = '/accessRequest';
export const handleAccessRequestEndpoint = '/handleRequest';
export const requestedAssignmentsEndpoint = '/requestedAssignments';

// Events
export const registerEndpoint = '/events/register';

// Backoffice AI
export const backofficeAIEndpoint = '/backofficeAI';

// Forecast
export const forecastEndpoint = '/forecast';

// KPI
export const areaKpiEndpoint = '/areaKpis';
export const targetEndpoint = '/kpiTargets';
export const targetLockEndpoint = '/locks';
export const areaCapEndpoint = '/:storeId/areaCaps';
export const areaTargetEndpoint = '/:storeId/kpis/:kpiName';
export const lastKpiEndpoint = '/latest';

// Feedback
export const feedBackEndpoint = '/feedback';

// Currency Conversion
export const currencyConversionEndpoint = '/currencyConversion';

// Area
export const areaComparisonEndpoint = '/areaComparison';
export const areaOverviewEndpoint = '/areaOverview';
export const salesOverviewEndpoint = '/sales';
export const memberOverviewEndpoint = '/members';
export const efficiencyOverviewEndpoint = '/efficiency';
export const queueCustomerOverviewEndpoint = '/queueAndCustomer';
export const rfidOverviewEndpoint = '/rfid';
export const budgetPlanOverviewEndpoint = '/budgetAndPlan';
export const kpiOverviewEndpoint = '/kpiTargets';
export const summaryWidgetsEndpoint = '/getCounts';

// Area Result
export const areaResultEndpoint = '/areaResult';
export const customerBaseValueViewEndpoint = '/customerBase';
export const salesEfficiencyViewEndpoint = '/salesAndEfficiency';
export const customerExperienceViewEndpoint = '/customerExperience';
export const areaResultBreakdownEndpoint = '/breakdown';

// Store Overview
export const storeOverviewEndpoint = '/salesOverview';
export const departmentEndpoint = '/departments';
export const topSoldEndpoint = '/products';
export const topPlannedEndpoint = '/topPlanned';
